import React, {Component} from 'react'
import './Header.css'

class Header extends Component {
  creditsClick(e) {
    e.target.innerText = 'made by Perry Fustero'
    e.target.classList.add('creditsClick')
  }

  creditsRelease(e) {
    e.target.innerText = "credits"
    e.target.classList.remove('creditsClick')
  }

  render() {
    return (
      <div className='headerContainer'>
        <header className='headerBox'>
          <div className='logo'></div>
          <h1 className='title'>Make-A-Mix</h1>
          <a href='http://www.ypci.org/home.html'>
            <img 
              className='logo' 
              src='./YPCI-logo.png' 
              alt='Youth Popular Culture Institute Logo'
            />
          </a>
        </header>
        <div 
          className='credits' 
          onMouseDown={e => this.creditsClick(e)}
          onMouseUp={e => this.creditsRelease(e)}
        >credits</div>
      </div>
    )
  }
}

export default Header 


// WEBPACK FOOTER //
// ./src/Header/Header.js